export default function getErrorCode(error) {
  if (!error) {
    return null;
  }

  return (error.graphQLErrors || []).map((e) => e?.extensions?.code).find((e) => e);
}
